import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import * as Page1 from "./budgetCentralePerArea/Page";
import * as Page2 from "./budgetLocalePerArea/Page";
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from "src/mtska-frontend-app-component";

const Container = ({ dataProviderName, filters }) => {
    const { t } = useTranslation();
    const [reportVisible, setReportVisible] = useState(true);
    const showFilters = true;
    const showKPI = true;

    const report = [
        {
            title: t('Budget'),
            icon: 'faMoneyBillTransfer',
            pages: [
                {
                    title: t('Centrale per Area'),
                    icon: 'faGlobe',
                    component: <Page1.default dataProviderName={dataProviderName} filters={filters} key={1} />
                },
                {
                    title: t('Locale per Area'),
                    icon: 'faShop',
                    component: <Page2.default dataProviderName={dataProviderName} filters={filters} key={2} />
                }
            ]
        }
    ];

    return (
        <Box>
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Budget status')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filters} />
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
        </Box>
    )
}

export default Container;